import { Link } from "@inertiajs/react";
import { usePage } from "@inertiajs/react";
import { AnimatePresence, motion } from "motion/react";
import { X, Search, User, Heart, ShoppingBag } from "lucide-react";

export function MobileNav({ open, onClose }) {
  const { navigation = {} } = usePage().props;
  const mainNavigation = navigation.mainNavigation ?? [];

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <motion.button
            type="button"
            aria-label="Close mobile menu"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/45 backdrop-blur-sm"
          />

          <motion.aside
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            className="absolute right-0 top-0 h-full w-[88%] max-w-sm overflow-y-auto bg-[#fff7fa] p-5 shadow-2xl"
          >
            <div className="flex items-center justify-between border-b border-rose-100 pb-5">
              <Link
                href="/"
                onClick={onClose}
                className="flex items-center gap-3 font-black tracking-[0.35em]"
              >
                <span className="flex size-10 items-center justify-center rounded-full bg-[#f51b75] text-sm text-white">
                  CT
                </span>
                CAPTEX
              </Link>

              <button
                type="button"
                aria-label="Close menu"
                onClick={onClose}
                className="rounded-full border border-rose-100 bg-white p-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#d80b67]"
              >
                <X className="size-4" />
              </button>
            </div>

            <nav className="mt-6 space-y-2" aria-label="Mobile navigation">
              {mainNavigation.map((item) => (
                <Link
                  key={item.label}
                  href={item.href}
                  onClick={onClose}
                  className={`flex items-center justify-between rounded-2xl px-4 py-3 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-ring ${
                    item.highlight
                      ? "bg-[#f51b75] text-white"
                      : item.accent
                        ? "bg-white text-slate-900 ring-1 ring-rose-100"
                        : "text-slate-700 hover:bg-white"
                  }`}
                >
                  {item.label}
                  {item.highlight && (
                    <span className="rounded-full bg-white/15 px-2 py-0.5 text-[10px] uppercase tracking-widest">
                      Hot
                    </span>
                  )}
                </Link>
              ))}
            </nav>

            <div className="mt-8 grid grid-cols-2 gap-3">
              <MobileAction icon={Search} label="Search" href="/search" onClose={onClose} />
              <MobileAction icon={User} label="Account" href="/account" onClose={onClose} />
              <MobileAction icon={Heart} label="Wishlist" href="/wishlist" onClose={onClose} />
              <MobileAction icon={ShoppingBag} label="Checkout" href="/checkout" onClose={onClose} />
            </div>
          </motion.aside>
        </div>
      )}
    </AnimatePresence>
  );
}

function MobileAction({ icon: Icon, label, href, onClose }) {
  return (
    <Link
      href={href}
      onClick={onClose}
      className="rounded-2xl border border-rose-100 bg-white p-4 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-[#fff3f7] focus:outline-none focus:ring-2 focus:ring-[#d80b67]"
    >
      <Icon className="mb-3 size-5" aria-hidden="true" />
      {label}
    </Link>
  );
}
